import React from 'react';
import { Link } from 'react-router-dom';
import { useReveal } from '../hooks/useReveal';

// Homepage About teaser (Fase 2). A compact, personal bridge between the work
// and the services — photo + one strong line + a short intro that hands off to
// the full /about page for the deeper story (experience, education, skills).
const HomeAboutTeaser = () => {
  const ref = useReveal();

  return (
    <section ref={ref} className="bg-surface py-20 sm:py-24 lg:py-32 border-t border-hairline">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-[0.85fr_1.15fr] gap-10 lg:gap-16 items-center">
          {/* Photo */}
          <div className="reveal-up relative order-1 lg:order-none">
            <div className="relative overflow-hidden rounded-[24px] border border-hairline">
              <img
                src="/images/about-pag.jpeg"
                alt="Sander Kuyken"
                loading="lazy"
                className="w-full h-[340px] sm:h-[440px] lg:h-[520px] object-cover"
              />
            </div>
          </div>

          {/* Copy */}
          <div className="flex flex-col gap-8">
            <span className="reveal-up eyebrow text-[#f97b22]">About me</span>

            <h2 className="reveal-up font-bricolage font-extrabold text-mainkleur text-[34px] sm:text-[46px] lg:text-[58px] leading-[1.02] tracking-[-1.5px]">
              A Belgian designer who treats every brief like a chance to prove what a next-gen studio can do.
            </h2>

            <p className="reveal-up font-space text-muted text-[16px] sm:text-[18px] lg:text-[20px] leading-[1.55] max-w-[640px]">
              I'm Sander — 4+ years across branding, motion, 3D/VFX and web/UX, pairing
              creative direction with technical craft. The full story — how I work,
              experience, education and tools — lives on the about page.
            </p>

            <div className="reveal-up">
              <Link
                to="/about"
                className="group inline-flex items-center gap-3 font-bricolage font-semibold text-mainkleur text-lg sm:text-xl uppercase tracking-tight hover:text-[#f97b22] transition-colors duration-300"
              >
                <span>More about me</span>
                <span className="w-10 h-10 sm:w-12 sm:h-12 rounded-full border-2 border-mainkleur group-hover:bg-mainkleur group-hover:text-licht flex items-center justify-center transition-all duration-300 group-hover:rotate-[-45deg]">
                  <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeAboutTeaser;
